"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.REAL_TIME_EVENT = void 0;
var REAL_TIME_EVENT = exports.REAL_TIME_EVENT = "configuration-update-event";